import React, { Component } from 'react';
import ContentBackground from '../ui/contentBackground';
import VideoPlayer from '../ui/videoPlayer';
import Modal from '../ui/modal';
import CircleButton from '../ui/circleButton';
import ArrowDownButton from './arrowDownButton';
import * as style from './hero.module.scss';
import translations from '../../utils/translations';

class Hero extends Component {
  constructor() {
    super();
    this.state = {
      playVideo: false,
      isClosing: false,
    };
  }
  playVideo = () => {
    this.setState({
      playVideo: true,
    });
  };
  hideVideo = () => {
    this.setState({ playVideo: false, isClosing: true }, () => {
      setTimeout(() => {
        this.setState({ isClosing: false });
      }, 1000);
    });
  };
  render() {
    return (
      <div
        className={`hero homepage${
          this.state.playVideo ? ' hero--videoPlaying' : ''
        }${this.props.isCoreCurriculum === true ? ' core-curriculum-hero' : ''}`}
      >
        <ContentBackground
          src={this.props.imageSrc}
          videoSrc={this.props.videoSrc}
          videoEmbed={this.props.videoEmbed}
          poster={this.props.posterSrc}
          opacity={0.7}
          videoOpacity={1}
          playEmbed={this.props.videoEmbed && this.state.playVideo}
          paused={!this.state.playVideo}
        />

        {(this.state.playVideo || this.state.isClosing) && (
          <Modal
            toggleOpen={this.hideVideo}
            exiting={this.state.isClosing}
            basicFade
            fullScreen
          >
            <VideoPlayer
              videoUrl={this.props.videoEmbed.url}
              videoId={this.props.videoEmbed.id}
              onVideoComplete={this.hideVideo}
              vidId={'heroVid'}
              fullScreen
            />
          </Modal>
        )}

        <div className={`hero-inner`}>
          <div className={`container-inner`}>
            <div className={`hero-heading`}>
              <span
                className={`f-label fadeInBlur ${
                  this.props.shouldReveal ? 'animated delay-1s' : ''
                }`}
              >
                {this.props.label}
              </span>
              <div className={`typeFonts1`}>
                <h1
                  className={`hero-title fadeInBlur ${
                    this.props.shouldReveal ? 'animated delay-1-4s' : ''
                  }`}
                  dangerouslySetInnerHTML={{ __html: this.props.title }}
                />
              </div>
              <div
                className={`hero-desc fadeInBlur typeFonts2 ${
                  this.props.shouldReveal ? 'animated delay-1-8s' : ''
                }`}
                dangerouslySetInnerHTML={{
                  __html: this.props.short_description,
                }}
              />
              {this.props.videoEmbed && (
                <div
                  className={`hero-desc hero-button fadeInBlur ${
                    this.props.shouldReveal ? 'animated delay-2-2s' : ''
                  }`}
                >
                  <CircleButton
                    type="play"
                    kicker="Watch"
                    text={this.props.videoEmbed.name}
                    handleClick={this.playVideo}
                    textStyleAlt
                    textRight
                    smallLeft
                    bigger
                  />
                </div>
              )}
            </div>
            {(this.props.hideExplore === undefined || this.props.hideExplore === false) &&
              <ArrowDownButton
                handleClick={this.props.scrollExplore}
                shouldReveal={this.props.shouldReveal}
                hasVideo={!!this.props.videoEmbed}
                text={translations.t('Explore')}
              />
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Hero;
